import {
  DirectOrderTrip,
  DIRECTS_ORDER_FIELDS,
} from "@/stores/direct-order/types";
import { ContactPersonType } from "@/stores/order/types";
import { generateId } from "./utils";
import { ORDER_TYPE } from "@/services/enums/commonEnum";

/**
 * Creates a new direct order trip with default values
 * @returns {DirectOrderTrip} A new direct order trip object with initialized fields
 */
export const createDirectOrderTrip = (): DirectOrderTrip => ({
  [DIRECTS_ORDER_FIELDS.GEN_TID]: generateId(),
  [DIRECTS_ORDER_FIELDS.ALT_TRIP_NAME]: "",
  [DIRECTS_ORDER_FIELDS.ORDER_TYPE]: ORDER_TYPE.SINGLE,
  [DIRECTS_ORDER_FIELDS.DEPARTURE_DATETIME]: "",
  [DIRECTS_ORDER_FIELDS.TRAVEL_FROM]: "",
  [DIRECTS_ORDER_FIELDS.ROUTE_POINTS]: { oneway: [], return: [] },
  [DIRECTS_ORDER_FIELDS.TRAVEL_TO]: "",
  [DIRECTS_ORDER_FIELDS.ARRIVAL_DATETIME]: "",
  [DIRECTS_ORDER_FIELDS.ARRIVAL_DATETIME_RETURN]: "",
  [DIRECTS_ORDER_FIELDS.BUS_AVAILABILITY]: false,
  [DIRECTS_ORDER_FIELDS.DISTANCE]: { oneway: 0, return: 0 },
  [DIRECTS_ORDER_FIELDS.DURATION]: { oneway: 0, return: 0 },
  [DIRECTS_ORDER_FIELDS.POC]: {} as ContactPersonType,
  [DIRECTS_ORDER_FIELDS.PAX]: "",
  [DIRECTS_ORDER_FIELDS.INVOICE_REF]: "",
  [DIRECTS_ORDER_FIELDS.COMMENT_CUSTOMER]: "",
  [DIRECTS_ORDER_FIELDS.WAITING_TIME]: 0,
  [DIRECTS_ORDER_FIELDS.PRICE_INC_VAT]: 0,
  [DIRECTS_ORDER_FIELDS.PRICE_EX_VAT]: 0,
});

/**
 * Utility function to convert tripsDictionary into "DirectOrderTrip[]"
 * @param tripsDictionary - The order form containing trips as a dictionary
 * @returns {DirectOrderTrip[]} An array of DirectOrderTrip objects
 * This function extracts the trips from the dictionary and returns them as an array.
 */
export const convertOrderFormTypeToTripArray = (
  tripsDictionary: Record<string, DirectOrderTrip>
): DirectOrderTrip[] => {
  return Object.values(tripsDictionary).map((trip) => ({
    ...trip,
  }));
};
